
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DZModelDicConfig from "@/model/DZModelDicConfig";
import DZModelHomestayBase from "@/views/审核管理/model/DZModelHomestayBase";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import uploadFile from "@/utils/DZUploadFile";
import nyMessageToast from "@/utils/NYMessageToast";
import nyNetwork from "@/api/nyBaseNetwork";
import ImgUtil from "@/utils/ImgUtil";

@Component
export default class Base extends Vue{

  rules = {
    title:[{ required: true, message: '请输入信息标题', trigger: 'blur' }],
    bigType:[{ required: true, message: '请输选择民宿大类', trigger: 'blur' }],
    smallType:[{ required: true, message: '请选择民宿小类', trigger: 'blur' }],
    houseArea:[{ required: true, message: '请输入房屋面积', trigger: 'blur' }],
    totalArea:[{ required: true, message: '请输入总面积', trigger: 'blur' }],
    price:[{ required: true, message: '请输入价格', trigger: 'blur' }],
    priceUnit:[{ required: true, message: '请输入价格单位', trigger: 'blur' }],
    accommodate:[{ required: true, message: '请输入住宿容纳', trigger: 'blur' }],
    houseType:[{ required: true, message: '请输入房屋类型', trigger: 'blur' }],
    leasingMethod:[{ required: true, message: '请输入租赁方式', trigger: 'blur' }],
    decorationLevel:[{ required: true, message: '请输入装修程度', trigger: 'blur' }],
    toiletType:[{ required: true, message: '请选择厕所类型', trigger: 'blur' }],
    toilet:[{ required: true, message: '请选择厢房厕所', trigger: 'blur' }],
    supportingFacilitiesArr:[{ required: true, message: '请选择房屋配套', trigger: 'blur' }],
    houseOrientation:[{ required: true, message: '请选择房屋朝向', trigger: 'blur' }],
    waterElectricityFees:[{ required: true, message: '请选择水电费', trigger: 'blur' }],
    describe:[{ required: true, message: '请输入详细介绍', trigger: 'blur' }],
  }

  imgUtil = new ImgUtil();

  created() {
    this.getBigType()
  }
  /** 民宿大类 **/
  list_bigType = []
  getBigType(){
    nyNetwork.net("标签获取字典分类",{label:'10004'}, data => {
      this.list_bigType = data
    })
  }

  /** 民宿小类 **/
  list_smallType = []

  /** 民宿小类 **/
  getSmallType(id){
    this.m_base.smallType = ''
    nyNetwork.get("字典列表查询",{id:id}, data => {
      this.list_smallType = data
    })
  }

  @Prop() data;

  @Prop() dic;

  flag = true

  formData = {
    totalAreaUnit:[]
  }

  dics = [];

  m_base = new DZModelHomestayBase();

  dic_config = new DZModelDicConfig();

  arr = [
    'homestayBigType',
    'homestaySmallType',
    'houseAreaUnit',
    'totalAreaUnit',
    'priceUnit',
    'leasingMethod',
    'decorationLevel',
    'toiletType',
    'supportingFacilities',
    'houseOrientation',
    'waterElectricityFees'
  ]

  refreshSelect (val) {
    this.$forceUpdate()
  }

  @Watch("data")
  watchData(value: any, oldValue: string) {
    if(value){
      this.m_base = value;
      if(this.m_base.toilet){
        this.m_base.toilet += ''
      }
      if(this.m_base.bigType){
        nyNetwork.get("字典列表查询",{id:this.m_base.bigType}, data => {
          this.list_smallType = data
        })
      }
      this.m_base.supportingFacilitiesArr = this.m_base.supportingFacilities.split(",")
      this.$forceUpdate()
    }
  }

  @Watch("dic")
  watchDic(value: any, oldValue: string) {
    if(value){
      this.dics = value;
      let idList = []
      this.arr.forEach( a =>{
        idList.push(this.dic_config.get(a))
      })
      this.dics.forEach( d =>{
        let index = idList.indexOf(d.typeId)
        if (index != -1) {
          this.formData[this.arr[index]] = d.dicList
        }
      })
      // @ts-ignore
      this.formData.totalAreaUnit = this.formData.houseAreaUnit
      console.log(this.formData)
      this.$forceUpdate()
    }
  }

  bindImage(id) {
    if (!id) {
      return "";
    }
    let apiName = "显示图片";
    let apiJson: ny_config = api[apiName];
    let url = apiJson.baseUrl + apiJson.url + "?image=" + id
    return url;
  }

  handle_edit(){
    this.flag = !this.flag
  }

  action_select_file(file,list,index) {
    if (file.status == "ready") {
      uploadFile.uploadImage(file.raw,
          (res) => {
          }, (res) => {
            nyMessageToast.success("图片上传成功")
            let idArr = this.m_base.imageIds.split(",")
            idArr[index] = res + ""
            let idStr = idArr.join(",")
            this.m_base.imageIds = idStr
            console.log(this.m_base.imageIds)
          }, (res) => {
            nyMessageToast.error("图片上传失败")
          });
    }
    this.$forceUpdate()
  }

  handle_submit(){
    // @ts-ignore
    this.$refs.form.validate(v=>{
      if(v){
        this.m_base.supportingFacilities = this.m_base.supportingFacilitiesArr.join(",")
        this.$emit('ny_submit', this.m_base)
        this.handle_edit()
      }else {
        nyMessageToast.warning("请输入必填项")
        return false
      }
    })


  }
}
